import { formatDate } from "../../../../../../../common/helpers/date.helpers"
import { IRenter, SignatureInfo } from "../../../../../../../types/renter.type"
import { calculateEndDate } from "../../../../../helpers/calculationUtils"
import { renewPlanRenter } from "../../../../../../../common/services/renters.api"
import { getIn, useFormikContext } from "formik"
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context"
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading"
import { useState } from "react"
import ZapSignActivate from "../../UploadInfoApis/ZapSignActivate"
import { createContract } from "../../../../../services/integration.api"
import ZapSignConfirmation from "../../UploadInfoApis/ZapSignConfirmation"
import { DateSubscriptionFormik } from "../../../../forms/fields/DateSubscriptionFormik"
import { getPlanDays, getPlanMonths } from "./AdditionsPlan"

type Props = {
  data: IRenter
}

type Period = {
  value: string,
  label: string,
  months: number,
  days?: number,
}

export default function RenewPlanModal(props: Props) {
  const formik = useFormikContext()
  const [signatureInfo, setSignatureInfo] = useState<SignatureInfo>()
  const renter = props.data;
  const disabledButton = /MENSAL/.test(renter.activationData?.plan.label) ? true : false
  const renterId = getIn(formik.values, 'renterId')
  const vehicleId = getIn(formik.values, 'vehicle._id');
  const additions = getIn(formik.values, 'additions')
  const subscriptionInitialDate = getIn(formik.values, 'subscriptionInitialDate')
  const [bindRenewPlan, setBindRenewPlan] = useState(false)
  const { notifySuccess, notifyError } = useToastContext()

  const newEndDate = calculateEndDate(renter.activationData?.plan.subscriptionEndDate, renter.activationData?.plan.planType);

  async function handleRenewPlan() {
    setBindRenewPlan(true)

    try {
      const renewPlanData = {
        renterId: renterId,
        vehicleId: vehicleId,
        newEndDate: new Date(newEndDate),
        subscriptionInitialDate: subscriptionInitialDate
      }

      const response = await renewPlanRenter(renewPlanData)

      if (!response.ok) {
        throw new Error('Erro ao renovar o plano')
      }

      notifySuccess('Plano renovado com sucesso')
    } catch (err) {
      console.error('Erro ao tentar renovar o plano:', err)
      notifyError(err instanceof Error ? err.message : 'Erro inesperado ao renovar o plano')
    } finally {
      setBindRenewPlan(false)
    }
  }

  function handleSignature(contractInfo) {
    setSignatureInfo(contractInfo)
  }
  const period: Period = {
    value: renter.activationData?.plan?.planType,
    label: (renter.activationData?.plan?.label),
    months: getPlanMonths(renter.activationData?.plan?.planType),
    days: getPlanDays(renter.activationData?.plan?.planType),
  };

  const contractData = {
    renterId: renterId,
    vehicleId: vehicleId,
    period: period,
    additions: additions,
  }

  return (
    <section className="flex flex-col gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-600" htmlFor="otherReason ">Nova data final:</label>
        <label className="font-bold text-[16px]">{formatDate(newEndDate)}</label>
      </div>

      <div>
        <DateSubscriptionFormik />
      </div>

      <div className="flex flex-col gap-1">
        <label className="block text-sm font-medium text-gray-600" htmlFor="otherReason ">Complemento</label>
        <textarea
          id="otherReason"
          name="otherReason"
          style={{ resize: "none", height: "90px" }}

        />
      </div>

      <div className="flex justify-end mb-6">
        <span className="absolute left-0 bottom-full mb-2 hidden w-40 px-2 py-1 text-xs text-redPrimary bg-black rounded group-hover:block">
          Não é possível clicar porque o cliente não possui veículo vinculado.
        </span>
        <ButtonWithLoader
          type="button"
          isLoading={bindRenewPlan}
          onClick={handleRenewPlan}
          disabled={disabledButton}
          message="Não é possível renovar cliente com plano mensal."
        >
          Renovar Plano
        </ButtonWithLoader>
      </div>

      <div className="mt-4">
        <ZapSignActivate
          onSave={function (): void {
            throw new Error('Function not implemented.');
          }} contractData={contractData}
          handleSignature={handleSignature}
          contractFn={createContract} />
        {signatureInfo?.ok && (
          <ZapSignConfirmation
            contractInfo={signatureInfo}
          />)}
      </div>

    </section>
  )
}